<template>
  <b-row>
    <b-col>
      <div
        v-if="!liveJobTimings.length && fetchingTiming"
        class="py-3 text-center"
      >
        <b-spinner />
      </div>
      <div v-else>
        <div class="d-flex justify-content-end mb-1">
          <b-button
            v-if="!isEnded"
            variant="bg-white"
            :disabled="fetchingTiming"
            @click="refresh"
          >
            <GjIcon
              name="Refresh"
              class="icon-left"
            />
            Refresh
          </b-button>
        </div>
        <b-table
          ref="table"
          :items="liveJobTimings"
          :fields="fields"
          responsive
          show-empty
          class="loaded border-default border-b border-r border-l rounded"
          :busy="fetchingTiming"
        >
          <template #cell(index)="data">
            {{
              currentPage > 1
                ? (currentPage - 1) * 10 + (data.index + 1)
                : data.index + 1
            }}
          </template>
          <template #cell(startDateTime)="data">
            {{ formatDateTimeDetailed(data.value) }}
          </template>
        </b-table>
        <div
          v-if="liveJobTimings.length > 0"
          class="default-pagination"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalCount"
            :per-page="pageSize"
            first-number
            last-number
          />
          <div class="results">
            Viewing {{ first.toLocaleString() }} to {{ last.toLocaleString() }} of {{ totalCount.toLocaleString() }} Items
          </div>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'LiveJobTimingLogs',
  props: {
    isEnded: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: true,
      required: true,
    },
  },
  data() {
    return {
      initialized: false,
      fields: [
        { key: 'index', label: '' },
        'status',
        { key: 'messageComment', label: 'message' },
        { key: 'startDateTime', label: 'timestamp' },
      ],
      tableData: [],
      currentPage: 1,
    }
  },
  computed: {
    resultInfo() {
      return this.$store.state.liveEncoder.timingsResultInfo
    },
    totalCount() {
      return this.resultInfo.totalCount
    },
    pageSize() {
      return this.resultInfo.pageSize || 10
    },
    pageIndex() {
      return this.currentPage - 1
    },
    first() {
      return this.pageIndex * this.pageSize + 1
    },
    last() {
      return this.currentPage * this.pageSize < this.totalCount
        ? this.currentPage * this.pageSize
        : this.totalCount
    },
    liveJobTimings() {
      return this.$store.state.liveEncoder.liveJobTimings
    },
    fetchingTiming() {
      return this.$store.state.liveEncoder.gettingLiveJobTimings
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.fetchTiming()
      }
    },
    currentPage() {
      this.fetchTiming()
    },
  },
  methods: {
    refresh() {
      this.currentPage = 1
      this.fetchTiming()
    },
    fetchTiming() {
      this.$store
        .dispatch('liveEncoder/getLiveJobTiming', {
          jobId: this.$route.params.name,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        })
        .catch(error => {
          this.errorToast(
            error.response?.data?.errors[0]
              || 'Something went wrong while fetching live job timings.',
          )
        })
    },
  },
}
</script>

<style>
.header-class {
  padding: 16px 0;
}
</style>
